export { default as FormMail } from './FormMail'
export { default as FormPass } from './FormPass'
export { default as FormTxt } from './FormTxt'
export { default as FormTxtArea } from './FormTxtArea'
export { default as FormSelect } from './FormSelect'
export { default as FormChips } from './FormChips'
export { default as FormCheck } from './FormCheck'
export { default as FormTypeahead } from './FormTypeahead'
export { default as FormChipsSearch } from './FormChipsSearch'
export { default as FormMultiSelect } from './FormMultiSelect'
export { default as FormNumber } from './FormNumber'
export { default as FormSwitch } from './FormSwitch'
export { default as FormNumberStep } from './FormNumberStep'
export { default as FormOtp } from './FormOtp'
